import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import leftImage from "../../assets/ventures2.png"; 
import Logo from "../../assets/ventures.png"; 
import { FiChevronDown, FiArrowRight } from "react-icons/fi";

import Icon1 from "../../assets/icon1.png"; 
import Icon2 from "../../assets/icon2.png"; 
import Icon3 from "../../assets/icon3.png"; 
import Icon4 from "../../assets/icon4.png"; 

const ventures = [
  {
    icon: <img src={Icon1} alt="HR Icon" className="w-10 h-10" />,
    title: "Butterfly HR Consulting & Training",
    subtitle: "Shaping Careers, Strengthening Organizations",
    details:
      "We provide HR consulting, leadership development, and corporate training solutions designed to transform organizations.",
    buttonText: "Explore More",
    link: "https://butterflyhrglobal.com/",
  },
  {
    icon: <img src={Icon2} alt="Construction Icon" className="w-10 h-10" />,
    title: "Butterfly Construction",
    subtitle: "Building the Foundations of Tomorrow",
    details:
      "From residential to commercial projects, our construction services focus on innovation, safety, and durability.",
    buttonText: "Discover More",
    link: "https://butterflyconstructions.com/",
  },
  {
    icon: <img src={Icon3} alt="Decor Icon" className="w-10 h-10" />,
    title: "Butterfly Decors",
    subtitle: "Designs That Breathe Life Into Spaces",
    details:
      "We bring life into interiors with creative decor solutions, blending aesthetics with functionality.",
    buttonText: "Step Inside",
    link: "https://butterflydecors.in",
  },
  {
    icon: <img src={Icon4} alt="Wellness Icon" className="w-10 h-10" />,
    title: "Butterfly Wellness Clinic",
    subtitle: "Healing Minds, Empowering Lives",
    details:
      "Our wellness clinic provides therapy, healing practices, and wellness programs to empower a balanced life.",
    buttonText: "Fly With Us",
    link: "/wellness",
  },
];

const ButterflyVentures = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleDropdown = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="bg-[#F6F6F6] py-12 px-4 sm:px-8 md:px-12">
      <div
        className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center"
        data-aos="fade-right"
      >
        {/* Left Image Section */}
        <div className="flex justify-center relative">
          <img
            src={Logo}
            alt="Background Logo"
            className="absolute inset-0 w-64 h-64 sm:w-80 sm:h-80 md:w-[500px] md:h-[500px] object-contain opacity-90 -z-0 m-auto"
          />
          <img
            src={leftImage}
            alt="Butterfly Ventures"
            className="relative z-10 max-w-xs sm:max-w-sm md:max-w-md w-full object-contain"
          />
          <div className="absolute bottom-0 left-0 right-0 h-20 sm:h-28 md:h-32 bg-gradient-to-t from-white to-transparent z-20"></div>
        </div>

        {/* Right Ventures List */}
        <div className="text-center md:text-left">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6">
            THE BUTTERFLY VENTURES
          </h2>

          <div className="space-y-4">
            {ventures.map((item, index) => (
              <div
                key={index}
                className="bg-white shadow-md rounded-lg px-5 py-5 hover:shadow-lg transition"
              >
                <div
                  className="flex items-center justify-between cursor-pointer"
                  onClick={() => toggleDropdown(index)}
                >
                  <div className="flex items-center space-x-4 text-left">
                    {item.icon}
                    <div>
                      <h3 className="font-semibold text-gray-900 text-sm sm:text-base">
                        {item.title}
                      </h3>
                      <p className="text-gray-600 text-xs sm:text-sm">
                        {item.subtitle}
                      </p>
                    </div>
                  </div>
                  <FiChevronDown
                    className={`text-teal-500 text-xl transform transition-transform ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  />
                </div>

                {/* Dropdown Content */}
                {openIndex === index && (
                  <div className="mt-3 text-gray-600 text-sm border-t pt-3 space-y-3">
                    <p>{item.details}</p>
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-800 transition"
                    >
                      {item.buttonText}
                      <FiArrowRight className="ml-2" />
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ButterflyVentures;
